








































import {Component, Mixins} from "vue-property-decorator";
import {namespace} from "vuex-class";
import NotificationMixin from "@/mixins/notification.mixin";
import * as _ from "lodash";

const Configurations = namespace("ConfigurationsModule");

@Component({
  name: "Configuration",
  mixins: [NotificationMixin],
  components: {},
})
export default class Configuration extends Mixins(NotificationMixin) {
  loading = false;
  envsNew = '';
  addnew = false;
  showBack = false;
  envToShow = -1;
  envsList: Array<any> = [];

  mounted() {
    const url = this.$route.query;
    if (url.goback == 'configuration' ) {
      this.showBack = true;
    }
    this.getData();
  }

  private async getData() {
    await this.getConfig();
    this.envsList = _.clone(this.Environments);
  }

  private addEnvs() {
    this.envToShow = this.envsList.push(this.envsNew) - 1;
    this.envsNew = '';
  }

  private deleteEnvs(value: any) {
    if(confirm("Are you sure you want to delete this environment?")){
      const index = this.envsList.indexOf(value, 0);
      if (index > -1) {
        this.envsList.splice(index, 1);
      }
      this.saveConfiguartion();
    }
  }

  private deleteEnvsAddNew() {
    this.envsNew = '';
    this.addnew = false;
  }

  private async saveConfiguartion() {
    this.loading = true;
    if (this.envsNew != '') {
      this.envsList.push(this.envsNew);
      this.envsNew = '';
      this.addnew = false;
    }
    const result = await this.saveConfig({
      Environments: this.envsList,
    });
    if (result.success) {
      this.onShowFlashMessage("Update configuration successfully!");
    } else {
      this.onShowFlashMessage(result.message, "Error", "danger");
    }
    this.loading = false;
    this.envToShow = -1;
  }

  clickBackConfiguration() {
    this.$router.push({name: "Configuration"});
  }

  @Configurations.State
  public Environments!: Array<string>;

  @Configurations.Action
  public saveConfig!: (params: object) => Promise<any>;

  @Configurations.Action
  public getConfig!: () => Promise<any>;
}
